// Generated by purs version 0.15.15
import * as Data_Coordinates from "../Data.Coordinates/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Site_Types_Id from "../Restaumatic.Site.Types.Id/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Coordinates.eqCoordinates));
var eq1 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Site_Types_Id.eqSiteId);
var locationIsSymbol = {
    reflectSymbol: function () {
        return "location";
    }
};
var siteIdIsSymbol = {
    reflectSymbol: function () {
        return "siteId";
    }
};
var GetRestaurantsIsSymbol = {
    reflectSymbol: function () {
        return "GetRestaurants";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var GetRestaurants = function (x) {
    return x;
};
var toFillFormTypeGetRestaura = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var rPCSitesGetRestaurantsArr = {};
var rPCMethodNameGetRestauran = {
    rpcMethodName: function (v) {
        return "GetRestaurants";
    }
};
var newtypeGetRestaurants_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldGetRestaurants = function (dictHasField) {
    return dictHasField;
};
var eqGetRestaurants = {
    eq: function (x) {
        return function (y) {
            return eq(x.location)(y.location) && eq1(x.siteId)(y.siteId);
        };
    }
};
var genericGetRestaurants = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGetRestaurants = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetRestaurants)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(locationIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(siteIdIsSymbol)(Restaumatic_Site_Types_Id.showSiteId))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Coordinates.showCoordinates)))))(GetRestaurantsIsSymbol))
};
var unscrambleDecodeGetRestaurants = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetRestaurants)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(locationIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Data_Coordinates.unscrambleDecodeCoordinates))(/* #__PURE__ */ Unscramble.decodeRecordCons(siteIdIsSymbol)(Restaumatic_Site_Types_Id.udecodeSiteId)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var encodeGetRestaurants = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericGetRestaurants)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(GetRestaurantsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(siteIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Site_Types_Id.encodeSiteId)))(locationIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Data_Coordinates.encodeCoordinates)))))))
};
var decodeGetRestaurants = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericGetRestaurants)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(GetRestaurantsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(siteIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Site_Types_Id.decodeSiteId))())(locationIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Data_Coordinates.decodeCoordinates)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    GetRestaurants,
    genericGetRestaurants,
    eqGetRestaurants,
    showGetRestaurants,
    rPCMethodNameGetRestauran,
    rPCSitesGetRestaurantsArr,
    encodeGetRestaurants,
    decodeGetRestaurants,
    unscrambleDecodeGetRestaurants,
    toFillFormTypeGetRestaura,
    hasFieldGetRestaurants,
    newtypeGetRestaurants_
};
